export type ClubPostType = 'update' | 'announcement' | 'meetup';
export type EventPostType = 'update' | 'announcement' | 'schedule' | 'logistics';
export type CommunityPostType = ClubPostType | EventPostType;
export type CommunityPostScope = 'club' | 'event';

export interface CommunityPostAuthor {
  id: number;
  username: string;
  display_name: string;
}

export interface CommunityPost {
  id: number;
  scope: CommunityPostScope;
  club_id?: number | null;
  event_id?: number | null;
  title?: string | null;
  body: string;
  body_preview?: string;
  post_type: CommunityPostType | string;
  is_pinned: boolean;
  status?: string;
  published_at?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  author: CommunityPostAuthor;
  can_edit?: boolean;
  can_delete?: boolean;
}

export interface CommunityPostsPage {
  items: CommunityPost[];
  page: number;
  limit: number;
  total: number;
  can_post?: boolean;
}

export interface CommunityPostInput {
  title?: string;
  body: string;
  post_type?: CommunityPostType | string;
  is_pinned?: boolean;
}

export interface HomeCommunityFeedItem {
  id: string;
  scope: CommunityPostScope;
  source_id: number;
  source_name: string;
  source_href: string;
  href: string;
  title?: string | null;
  body_preview: string;
  post_type: string;
  is_pinned?: boolean;
  published_at?: string | null;
  author_name: string;
}

export interface HomeClubShortcut {
  id: number;
  name: string;
  slug: string;
  logo_path?: string | null;
  region?: string | null;
  role: string;
  href: string;
}

export const CLUB_POST_TYPE_OPTIONS: Array<{ value: ClubPostType; label: string; hint: string }> = [
  { value: 'update', label: 'Update', hint: 'General news for members' },
  { value: 'announcement', label: 'Announcement', hint: 'Something important' },
  { value: 'meetup', label: 'Meetup', hint: 'When and where to gather' },
];

export const EVENT_POST_TYPE_OPTIONS: Array<{ value: EventPostType; label: string; hint: string }> = [
  { value: 'update', label: 'Update', hint: 'General note for entrants' },
  { value: 'announcement', label: 'Announcement', hint: 'Important notice' },
  { value: 'schedule', label: 'Schedule', hint: 'Timing changes' },
  { value: 'logistics', label: 'Logistics', hint: 'Parking, check-in, weather' },
];

export function communityPostTypeLabel(type: string): string {
  const map: Record<string, string> = {
    update: 'Update',
    announcement: 'Announcement',
    meetup: 'Meetup',
    schedule: 'Schedule',
    logistics: 'Logistics',
  };
  return map[type] || 'Update';
}
